import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ComposeTemplateEmailComponent } from './compose-template-email/compose-template-email.component';
import { UiModule } from 'src/app/ui/ui.module';
import { ComposeTemplateDialogComponent } from './compose-template-dialog/compose-template-dialog.component';
import { NgxEditorModule } from 'ngx-editor';
import { ItineraryUrlPipe } from '../trip-components/pipes/itinerary-url.pipe';




@NgModule({
  declarations: [
    ComposeTemplateEmailComponent,
    ComposeTemplateDialogComponent
  ],
  imports: [
    CommonModule,
    UiModule,
    NgxEditorModule
  ],
  providers: [CurrencyPipe, ItineraryUrlPipe]
})
export class EmailTemplateModule { }
